import React, { ReactElement, useEffect, useState } from 'react';
import { useAppToolchain } from 'src/hooks/useAppToolchain';


function OidcSignin(): ReactElement {
	const [signinValid, setSigninValid] = useState(false);
	const { oidcUserManager } = useAppToolchain();

	useEffect(() => {
		oidcUserManager
			.signinRedirectCallback()
			.then(() => {
				// Remove code/state params from URL after successful signin
				if (window && window.history && window.location) {
					const url = new URL(window.location.href);
					url.searchParams.delete('code');
					url.searchParams.delete('state');
					url.searchParams.delete('session_state');
					window.history.replaceState({}, document.title, url.pathname + url.search);
				}
				setSigninValid(true);
			})
			.catch((e) => {
				console.error(e);
			});
	}, []);

	useEffect(() => {
		if (signinValid) {
			window.location.replace('/detections');
		}
	}, [signinValid]);

	return (
		signinValid ? null : <div>Waiting for redirect...</div>
	);
}

export default OidcSignin;
